import React from 'react';
import {CloseSharp} from '@material-ui/icons';
import './FilterChipComponentStyle.scss';
import {Typography} from '@material-ui/core';

declare type FilterChipValue = string | React.ReactNode;
interface FilterChipComponentProps {
  value: FilterChipValue;
  onRemove?(value: FilterChipValue): void;
}
const FilterChipComponent: React.FC<FilterChipComponentProps> = props => {
  const {value, onRemove} = props;
  const handleClick = () => {
    if (typeof onRemove === 'function') {
      onRemove(value);
    }
  };
  return (
    <div className={'filter-chip-wrapper'}>
      <Typography color="primary" className={'label'}>
        {value}
      </Typography>
      <span
        onClick={handleClick}
        className="icon-wrapper"
        data-test-id="pcl-statements-filterChipClose">
        <CloseSharp color="primary" />
      </span>
    </div>
  );
};

export default FilterChipComponent;
